import { render, staticRenderFns } from "./SplitCard.vue?vue&type=template&id=fda53800"
import script from "./SplitCard.vue?vue&type=script&lang=js"
export * from "./SplitCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports